import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

function AppTableActionMenu({
	items,
	minWidth = 152,
	triggerIcon,
	triggerAriaLabel = "Ações",
}) {
	const [open, setOpen] = useState(false);
	const [dropdownStyle, setDropdownStyle] = useState(null);
	const [theme, setTheme] = useState("light");
	const containerRef = useRef(null);
	const buttonRef = useRef(null);
	const menuRef = useRef(null);

	const visibleItems = (items || []).filter(Boolean);

	useEffect(() => {
		if (!open) return undefined;

		const updatePosition = () => {
			if (!buttonRef.current) return;

			const rect = buttonRef.current.getBoundingClientRect();
			const menuHeight = menuRef.current?.offsetHeight || visibleItems.length * 40 + 8;
			const shouldOpenUp = window.innerHeight - rect.bottom < menuHeight + 12;
			const appRoot =
				buttonRef.current.closest(".tailwick-app") ||
				document.querySelector(".tailwick-app");

			setTheme(appRoot?.getAttribute("data-theme") || "light");

			setDropdownStyle({
				position: "fixed",
				top: shouldOpenUp ? rect.top - 4 : rect.bottom + 4,
				left: rect.right,
				transform: shouldOpenUp
					? "translate(-100%, -100%)"
					: "translateX(-100%)",
				minWidth,
				zIndex: 99999,
			});
		};

		const close = (e) => {
			if (
				containerRef.current?.contains(e.target) ||
				menuRef.current?.contains(e.target)
			) {
				return;
			}
			setOpen(false);
			setDropdownStyle(null);
		};

		updatePosition();
		document.addEventListener("mousedown", close);
		window.addEventListener("resize", updatePosition);
		window.addEventListener("scroll", updatePosition, true);

		return () => {
			document.removeEventListener("mousedown", close);
			window.removeEventListener("resize", updatePosition);
			window.removeEventListener("scroll", updatePosition, true);
		};
	}, [open, minWidth, visibleItems.length]);

	const dropdown = open ? (
		<div
			ref={menuRef}
			className={`app-table-dropdown app-table-dropdown--${theme} rounded-md border py-1 shadow-lg`}
			role="menu"
			style={dropdownStyle || { position: "fixed", visibility: "hidden" }}
		>
			{visibleItems.map((item) => (
				<button
					key={item.key || item.label}
					type="button"
					role="menuitem"
					className={
						item.tone === "danger"
							? "app-table-dropdown__item app-table-dropdown__item--danger"
							: "app-table-dropdown__item"
					}
					onClick={() => {
						setOpen(false);
						setDropdownStyle(null);
						item.onClick?.();
					}}
				>
					{item.icon}
					{item.label}
				</button>
			))}
		</div>
	) : null;

	return (
		<div ref={containerRef} className="relative inline-flex">
			<button
				ref={buttonRef}
				type="button"
				className="btn size-7.5 bg-default-200 text-default-500 hover:border-primary/10 hover:bg-primary/10 hover:text-primary dark:bg-default-700 dark:hover:bg-primary/20"
				aria-haspopup="menu"
				aria-expanded={open}
				aria-label={triggerAriaLabel}
				onClick={() => setOpen((prev) => !prev)}
			>
				{triggerIcon}
			</button>
			{dropdown ? ReactDOM.createPortal(dropdown, document.body) : null}
		</div>
	);
}

export default AppTableActionMenu;
